import { Module } from 'vuex';
import { IRootState, client } from '@/store';
import { IEmployee, IPageParams, ICRUDResponse, IUserType, IUserRole } from '@/models';

export interface IEmployeeState {
  entities: Record<string, IEmployee>;
  currentPage: number[];
  pageParams: Partial<IPageParams>;
  types: IUserType[],
  roles: IUserRole[],
}

export const employee: Module<IEmployeeState, IRootState> = {
  namespaced: true,
  state: {
    entities: {},
    currentPage: [],
    pageParams: {
      per_page: 15,
    },
    types: [],
    roles: [],
  },
  actions: {
    getEntities({ commit }, params) {
      client
        .get<ICRUDResponse<IEmployee[]>>('employee', { params })
        .then(({ data: { data, ...pageParams } }) => {
          commit('setEntities', data);
          commit('setPageParams', pageParams);
        });
    },
    getEntity({ commit }, id) {
      client
        .get<ICRUDResponse<IEmployee>>(`employee/${id}`)
        .then(({ data }) => {
          commit('setEntities', data);
        });
    },
    getUserRoles({ commit }) {
      client
        .get<ICRUDResponse<IUserRole[]>>('role')
        .then(({ data }) => {
          commit('setUserRoles', data);
        });
    },
    createEntity({ dispatch }, entity: Omit<IEmployee, 'id'>) {
      return client
        .post('employee', entity)
        .then(({ data }) => {
          dispatch('getEntities')
          return data
        });
    },
    deleteEntity({ dispatch }, entity: IEmployee) {
      return client
        .delete(`employee/${entity.id}`)
        .then(() => dispatch('getEntities'));
    },
    updateEntity({ dispatch }, entity: IEmployee) {
      return client
        .put(`employee/${entity.id}`, entity)
        .then(({ data }) => {
          dispatch('getEntities')
          return data
        });
    },
  },
  mutations: {
    setEntities(state, datum: IEmployee | IEmployee[]) {
      const entities = Array.isArray(datum) ? datum : [datum];
      state.entities = entities.reduce(
        (acc, item) => ({ ...acc, [item.id]: item }),
        {},
      );
      state.currentPage = entities.map((entity) => entity.id);
    },
    setUserTypes(state, types: IUserType[]) {
      state.types = types;
    },
    setUserRoles(state, roles: IUserRole[]) {
      state.roles = roles;
    },
    setPageParams(
      state,
      pageParams: Omit<ICRUDResponse<IEmployee[]>, 'data'>,
    ) {
      state.pageParams = pageParams;
    },
  },
  getters: {
    entitiesSlice({ currentPage, entities }) {
      return currentPage.map((id) => entities[id]);
    },
  },
};
